export default __webpack_public_path__ + "static/media/2.16fd77c2.jpg";